module.exports = __webpack_public_path__ + "img/pic3.9e3b594c.png";